 export enum Languages {
  ENGLISH = 'en-EN',
  SPANISH = 'es-ES',
  FRENCH = 'fr-FR',
  GERMAN = 'de-DE'
 }
